import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6916a26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = { class: "card-body border-top p-9 pt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-5 section-title" }, "Informasi Umum Pesanan", -1))
const _hoisted_5 = { class: "row mb-5" }
const _hoisted_6 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_7 = { class: "row px-3" }
const _hoisted_8 = { class: "col-12 fv-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Sekolah", -1))
const _hoisted_10 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row px-3" }
const _hoisted_13 = { class: "col-12 fv-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Estimasi Cetak", -1))
const _hoisted_15 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row px-3" }
const _hoisted_18 = { class: "col-6 fv-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "harga", -1))
const _hoisted_20 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "col-6 fv-row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Jumlah", -1))
const _hoisted_24 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row px-3" }
const _hoisted_27 = { class: "col-12 fv-row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tanggal Pembayaran", -1))
const _hoisted_29 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "row px-3" }
const _hoisted_32 = { class: "col-12 fv-row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Sales", -1))
const _hoisted_34 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_37 = { class: "row px-3" }
const _hoisted_38 = { class: "col-12 fv-row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tanggal Pemesanan", -1))
const _hoisted_40 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row px-3" }
const _hoisted_43 = { class: "col-12 fv-row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Estimasi Selesai", -1))
const _hoisted_45 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "row px-3" }
const _hoisted_48 = { class: "col-12 fv-row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Total Pembayaran", -1))
const _hoisted_50 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row px-3" }
const _hoisted_53 = { class: "col-12 fv-row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Status Pembayaran", -1))
const _hoisted_55 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-5 section-title" }, "Informasi Proses Cetak Kartu", -1))
const _hoisted_58 = { class: "row mb-5" }
const _hoisted_59 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_60 = { class: "row px-3" }
const _hoisted_61 = { class: "col-12 fv-row" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Status Kartu", -1))
const _hoisted_63 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-5 section-title" }, "Pengiriman", -1))
const _hoisted_66 = { class: "row mb-5" }
const _hoisted_67 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_68 = { class: "row px-3" }
const _hoisted_69 = { class: "col-12 fv-row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Ekspedisi", -1))
const _hoisted_71 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "row px-3" }
const _hoisted_74 = { class: "col-12 fv-row" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Dokumen", -1))
const _hoisted_76 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = { class: "row px-3" }
const _hoisted_79 = { class: "col-12 fv-row" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Bukti Pengiriman", -1))
const _hoisted_81 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_82 = { class: "fv-help-block" }
const _hoisted_83 = { class: "col-lg-6 col-xs-12 fv-row" }
const _hoisted_84 = { class: "row px-3" }
const _hoisted_85 = { class: "col-12 fv-row" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "No Ekspedisi / Resi", -1))
const _hoisted_87 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_88 = { class: "fv-help-block" }
const _hoisted_89 = { class: "row px-3" }
const _hoisted_90 = { class: "col-12 fv-row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Surat Jalan", -1))
const _hoisted_92 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_93 = { class: "fv-help-block" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-5" }, null, -1))
const _hoisted_95 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_98 = [
  _hoisted_96,
  _hoisted_97
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "name",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Nama Sekolah",
                  modelValue: _ctx.detail.schoolName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detail.schoolName) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.schoolName == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.errorsMessage.errorschoolName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "startDate",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Estimasi Cetak",
                  modelValue: _ctx.detail.startDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.startDate) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.startDate == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.errorsMessage.errorstartDate), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "price",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Harga",
                  modelValue: _ctx.detail.price,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail.price) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.price == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.errorsMessage.errorprice), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "amount",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Jumlah",
                  modelValue: _ctx.detail.amount,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.amount) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.amount == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.errorsMessage.erroramount), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Field, {
                  type: "date",
                  name: "paymentDate",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Tanggal Pembayaran",
                  modelValue: _ctx.detail.paymentDate,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detail.paymentDate) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.paymentDate == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.errorsMessage.errorpaymentDate), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "salesName",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Nama Produk",
                  modelValue: _ctx.detail.salesName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.salesName) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.salesName == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.errorsMessage.errorsalesName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_component_Field, {
                  type: "date",
                  name: "orderDate",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Nama Produk",
                  modelValue: _ctx.detail.orderDate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detail.orderDate) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.orderDate == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.errorsMessage.errororderDate), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "endDate",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Estimasi Selesai",
                  modelValue: _ctx.detail.endDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.detail.endDate) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.endDate == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.errorsMessage.errorendDate), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "total",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Total",
                  modelValue: _ctx.detail.total,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detail.total) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.total == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.errorsMessage.errortotal), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "paymentStatus",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Status Pembayaran",
                  modelValue: _ctx.detail.paymentStatus,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.detail.paymentStatus) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.paymentStatus == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.errorsMessage.errorpaymentStatus), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _hoisted_57,
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "cardStatus",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Status Kartu",
                  modelValue: _ctx.detail.cardStatus,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.detail.cardStatus) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.cardStatus == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.errorsMessage.errorcardStatus), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _hoisted_65,
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "ekspedisi",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Status Kartu",
                  modelValue: _ctx.detail.ekspedisi,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.detail.ekspedisi) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.ekspedisi == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.errorsMessage.errorekspedisi), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createVNode(_component_Field, {
                  type: "file",
                  name: "dokumen",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Status Kartu",
                  modelValue: _ctx.detail.dokumen,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.detail.dokumen) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.dokumen == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.errorsMessage.errordokumen), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createVNode(_component_Field, {
                  type: "file",
                  name: "buktiPengiriman",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Status Kartu",
                  modelValue: _ctx.detail.buktiPengiriman,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.detail.buktiPengiriman) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.buktiPengiriman == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.errorsMessage.errorbuktiPengiriman), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "resi",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Status Kartu",
                  modelValue: _ctx.detail.resi,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.detail.resi) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.resi == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.errorsMessage.errorresi), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _hoisted_91,
                _createVNode(_component_Field, {
                  type: "file",
                  name: "suratJalan",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Status Kartu",
                  modelValue: _ctx.detail.suratJalan,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.detail.suratJalan) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.detail.suratJalan == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.errorsMessage.errorsuratJalan), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _hoisted_94
      ]),
      _createElementVNode("div", _hoisted_95, [
        _createElementVNode("button", {
          class: "btn btn-danger me-3",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$router.push('/superadmin/master-produk')))
        }, " Kembali "),
        _createElementVNode("button", {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.submitData())),
          class: "btn btn-primary"
        }, _hoisted_98)
      ])
    ])
  ], 64))
}